import React from "react";
import "./Page.css";
import useStore from "../store.js";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";

import Button from "../components/Button/Button.js";
import AudioPlayer from "../components/AudioPlayer/AudioPlayer.js";

const Page = (props) => {
  const getLocalized = useStore((state) => state.getLocalized);
  const game = useStore((state) => state.game);
  const setGameState = useStore((state) => state.setGameState);
  const isHost = useStore((state) => state.isHost);
  const gameState = useStore((state) => state.gameState);
  const hasPopupBild = useStore((state) => state.hasPopupBild);

  console.log("Story Game", game, getLocalized("game", "Story"));

  if (!game) return null;
  return (
    <div
      className={`Page${props.className ? " " + props.className : ""}${hasPopupBild ? " withPopupButton" : ""}`}
    >
      <div>
        <h1>{getLocalized("texts", "DieGeschichte")}</h1>

        {getLocalized("game", "Story") && (
          <BlocksRenderer content={getLocalized("game", "Story")} />
        )}
      </div>

      {/* {isHost && gameState == 0 && (
        <Button onClick={() => setGameState(1)}>
          <strong>
            {" "}
            {getLocalized("texts", "starten").replaceAll("%RUNDE%", "1")}
          </strong>
        </Button>
      )} */}
      {props.children}
    </div>
  );
};

export default Page;
